/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, October 19th 2022, 3:23:05 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import {
  APIMany2ManyCheckBoxFormInput,
  APIMany2ManyTransferListFormInput,
  ConcreteAPIMany2ManyTransferListFormInputProps,
} from "ui-widgets/forms";
import { APISERVICEPATHS } from "lib/api";
import { Permission } from "lib/schemas";
import ListItemText from "@mui/material/ListItemText";

export const PermissionsCheckboxesInput = <T,>(props) => (
  <APIMany2ManyCheckBoxFormInput<T, Permission>
    apiServicePath={APISERVICEPATHS.permissions}
    itemIdProperty="id"
    getOptionLabel={(option) => <ListItemText primary={option.name} />}
    {...props}
  />
);

export const PermissionsTransferListInput = <T,>(
  props: ConcreteAPIMany2ManyTransferListFormInputProps<T, Permission>
) => (
  <APIMany2ManyTransferListFormInput<T, Permission>
    apiServicePath={APISERVICEPATHS.permissions}
    itemIdProperty="id"
    getOptionLabel={(option) => <ListItemText primary={option.name} />}
    getSearchableName={(option) => `${option.name} ${option.codename}`}
    noDataMessage="No permissions found."
    {...props}
  />
);
